import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { useJobTracker } from '@nucleus-commerce/admin-kit/jobs';

import { importsApi } from '../api/imports-api';
import { isJobTerminal, JOB_POLL_POLICY, type TrackedJob } from '../schemas/job-rules';

import { jobKeys } from './job-keys';

/** Polls the import just uploaded until it completes or fails, then refreshes the job list. */
export function useTrackedImport(storeId: string, tracked: TrackedJob | null) {
  const queryClient = useQueryClient();
  const fetchJob = useCallback((id: string) => importsApi.get(storeId, id), [storeId]);
  const onTerminal = useCallback(
    () => void queryClient.invalidateQueries({ queryKey: jobKeys.imports(storeId) }),
    [queryClient, storeId],
  );
  return useJobTracker({
    jobId: tracked?.id,
    fetchJob,
    isTerminal: isJobTerminal,
    onTerminal,
    policy: JOB_POLL_POLICY,
    startedAt: tracked?.startedAt,
    queryKey: jobKeys.importTracking(storeId),
  });
}
